import { render, staticRenderFns } from "./Stancija.vue?vue&type=template&id=5cdd94c5&scoped=true&"
import script from "./Stancija.vue?vue&type=script&lang=js&"
export * from "./Stancija.vue?vue&type=script&lang=js&"
import style0 from "./Stancija.vue?vue&type=style&index=0&id=5cdd94c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd94c5",
  null
  
)

export default component.exports